import apiClient from '@u/apiClient'

export default {
  generateElysJWTKey({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`company/${payload.company_id}/elys/generate-key`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  checkElysConnection({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`company/${payload.company_id}/elys/check-connection`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysSearchDeceaseds({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `company/${payload.company_id}/elys/search-deceaseds`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetMunicipalities({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`company/${payload.company_id}/elys/municipalities`, payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysEligibleCompanies({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`company/elys-eligible`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetDeceasedById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(
          `company/${payload.company_id}/elys/dossier/${payload.deceased_id}/deceased`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysProcessAction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(
          `company/${payload.company_id}/elys/dossier/${payload.deceased_id}/action/${payload.action}`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetDeceasedTransportViewById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(
          `company/${payload.company_id}/elys/dossier/${payload.deceased_id}/transport-view`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetDossiers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`company/${payload.company_id}/elys/dossier`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  proceedPaiment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`company/${payload.company_id}/elys/paiement`, payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  proceedAction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`company/${payload.company_id}/elys/action`, payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetInformationSheet({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(
          `company/${payload.company_id}/elys/dossier/${payload.deceased_id}/information-sheet`
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysSendInformationSheet({ commit }, payload) {
    console.log(payload)
    let formData = new FormData()
    formData.append(
      'inlichtingenficheUitvaart',
      JSON.stringify(payload.data.form)
    )
    if (payload.data.file.VERZOEK_OPNAME_ALS_VADER_OF_MEEMOEDER) {
      formData.append(
        'VERZOEK_OPNAME_ALS_VADER_OF_MEEMOEDER',
        payload.data.file.VERZOEK_OPNAME_ALS_VADER_OF_MEEMOEDER,
        payload.data.file.VERZOEK_OPNAME_ALS_VADER_OF_MEEMOEDER.name
      )
    }
    if (
      payload.data.file
        .VERZOEK_NABESTAANDEN_PLAATSOVERLIJDEN_VERPLICHT_ALS_AS_PARTNER_VAN_TOEPASSING
    ) {
      formData.append(
        'VERZOEK_NABESTAANDEN_PLAATSOVERLIJDEN_VERPLICHT_ALS_AS_PARTNER_VAN_TOEPASSING',
        payload.data.file
          .VERZOEK_NABESTAANDEN_PLAATSOVERLIJDEN_VERPLICHT_ALS_AS_PARTNER_VAN_TOEPASSING,
        payload.data.file
          .VERZOEK_NABESTAANDEN_PLAATSOVERLIJDEN_VERPLICHT_ALS_AS_PARTNER_VAN_TOEPASSING
          .name
      )
    }
    if (payload.data.file.VERZOEK_NABESTAANDE) {
      formData.append(
        'VERZOEK_NABESTAANDE',
        payload.data.file.VERZOEK_NABESTAANDE,
        payload.data.file.VERZOEK_NABESTAANDE.name
      )
    }
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `company/${payload.company_id}/elys/dossier/${payload.deceased_id}/information-sheet`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysGetSocioEconomicInformation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(
          `company/${payload.company_id}/elys/dossier/${payload.deceased_id}/socio-economic-information`
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  elysSendSocioEconomicInformation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .put(
          `company/${payload.company_id}/elys/dossier/${payload.deceased_id}/socio-economic-information`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
